import { Injectable } from '@angular/core';
import { LocaleValue } from '@hjc/masterdata-types';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
  currentLang: LocaleValue = 'fi';
}
